import { render, staticRenderFns } from "./commit-info.vue?vue&type=template&id=be3bb076&scoped=true"
import script from "./commit-info.vue?vue&type=script&lang=js"
export * from "./commit-info.vue?vue&type=script&lang=js"
import style0 from "./commit-info.vue?vue&type=style&index=0&id=be3bb076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3bb076",
  null
  
)

export default component.exports